import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter"}/>
}
